import { Injectable, Inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable()
export class SettingsService{

  ajustes: Ajustes = {
      temaUrl: '',
      tema: 'bg-primary'
  }

  constructor(@Inject(DOCUMENT) private _document) {

   }



  guardarAjustes(){
      //console.log("Guardar");
      localStorage.setItem('ajustes', JSON.stringify(this.ajustes));
  }

  cargarAjustes(){
      if(localStorage.getItem('ajustes')){
       //   console.log("Cargando Ajustes");
          this.ajustes = JSON.parse(localStorage.getItem('ajustes'));
          this.aplicarTema(this.ajustes.tema);
      }else{
       // console.log("Default");
          //this.aplicarTema('navbar navbar-fixed-top navbar-shadow');
      }
  }

  aplicarTema(tema: any){


      if( this._document.getElementById('header')){
        this._document.getElementById('header').className = "navbar navbar-fixed-top navbar-shadow";
        this._document.getElementById('header').classList. add(tema);;

      }

      this.ajustes.tema = tema;

      this.guardarAjustes();

  }

}


interface Ajustes {
  temaUrl: any,
  tema: any
}
